import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContenedoresService } from './../../../../../../../../services/API/contenedores/contenedores.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { NotificationServiceService } from './../../../../../../../../services/notification-service/notification-service.service';

@Component({
    selector: 'app-edit-movimiento',
    templateUrl: './edit-movimiento.component.html',
    styleUrls: ['./edit-movimiento.component.css'],
    standalone: false
})
export class EditMovimientoComponent implements OnInit {

  showProgressBar: boolean = true;
  contenedores: any = [];
  contenedoresEntrega: any = [];
  contenedoresRetirada: any = [];
  movimiento: number = -1;
  form: UntypedFormGroup;
  tipo: string = 'entrega';
  contenedorEntrega: any = -1;
  contenedorRetirada: any = -1;
  fecha: any = "";
  fechaFinal: any = "";
  albaran: number;
  observaciones: string = '';
  cliente: string = '';
  latitud: string = '';
  longitud: string = '';

  constructor(private fb: UntypedFormBuilder, private contenedoresService: ContenedoresService, private notificationService: NotificationServiceService, 
              @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<EditMovimientoComponent>) { }

  ngOnInit(): void {
    if(this.data['contenedor'] === 'all'){
      this.contenedorEntrega = -1;
      this.contenedorRetirada = -1;
    }else{
      this.contenedorEntrega = this.data['contenedor'];
      this.contenedorRetirada = this.data['contenedor'];
    }
    this.movimiento = parseInt(this.data['movimiento']);
    this.tipo = this.data['tipo'];
    this.contenedorEntrega = parseInt(this.data['contenedorEntrega']);
    this.contenedorRetirada = parseInt(this.data['contenedorRetirada']);
    this.fecha = this.data['fecha'];
    this.albaran = parseInt(this.data['albaran']);
    this.observaciones = this.data['observaciones'];
    this.cliente = this.data['cliente'];
    this.latitud = this.data['latitud'];
    this.longitud = this.data['longitud'];

    var date = (this.data['fecha'].replace("-", "/")).replace("-", "/");
    date = date.split(/\//);
    date = [ date[1], date[0], date[2] ].join('/');
    this.fecha = new Date(date);
    this.fechaFinal = this.data['fecha'];

    this.getContenedores();
    this.form = this.fb.group({
      tipo: [this.tipo, [Validators.required, Validators.minLength(1)]],
      contenedorEntrega: [this.contenedorEntrega, []],
      contenedorRetirada: [this.contenedorRetirada, []],
      fecha: [this.fecha, [Validators.maxLength(128)]],
      albaran: [this.albaran, [Validators.required, Validators.minLength(1), Validators.maxLength(256), Validators.pattern("^[0-9]*$")]],
      observaciones: [this.observaciones, [Validators.maxLength(128)]],
      cliente: [this.cliente, [Validators.required, Validators.minLength(1), Validators.maxLength(128)]],
    });
  }

  getContenedores() {
    this.showProgressBar = true;
    this.contenedoresService.getContenedores('all').subscribe(result => {
      this.showProgressBar = false;
      this.contenedores = result;
      this.contenedoresEntrega = this.contenedores;
      this.contenedoresRetirada = this.contenedores;
    });
  }

  filterSelect_ContenedoresEntrega(value: string) { 
    this.contenedoresEntrega = this.contenedores.filter(option => option['matricula'].toLowerCase().includes(value.toLowerCase()));
  }

  filterSelect_ContenedoresRetirada(value: string) { 
    this.contenedoresRetirada = this.contenedores.filter(option => option['matricula'].toLowerCase().includes(value.toLowerCase()));
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      if(value.tipo === 'entrega' && value.contenedorEntrega.length === 0){
        this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
        return;
      }
      if(value.tipo === 'retirada' && value.contenedorRetirada.length === 0){
        this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
        return;
      }
      if(value.tipo === 'cambio' && (value.contenedorEntrega.length === 0 || value.contenedorRetirada.length === 0)){
        this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
        return;
      }
      this.showProgressBar = true;
      this.contenedoresService.updateMovimiento(this.movimiento, value.tipo, value.contenedorEntrega.toString(), value.contenedorRetirada.toString(), this.fechaFinal, value.albaran, value.observaciones, value.cliente, this.latitud, this.longitud).subscribe(() => {
        this.notificationService.openSnackBar("Movimiento modificado correctamente!");
        this.showProgressBar = false;
        this.close('save');
      }); 
    }else{
      this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
    }
  }

  close(data: string = '') {
    this.dialogRef.close(data);
  }

  dateChange(event: any){
    let fecha: any = new Date(event.target.value);
    fecha = fecha.getDate()+"-"+(fecha.getMonth()+1)+"-"+fecha.getFullYear();
    this.fechaFinal = fecha;
  }

  newLatitudEvent(latitud: any) {
    this.latitud = latitud;
  }

  newLongitudEvent(longitud: any) {
    this.longitud = longitud;
  }
  
}
